import { compose } from 'lodash/fp'
import TemplateSendModal from './TemplateSendModal'
import withState from './withState'

export default compose(withState)(TemplateSendModal)
